import * as THREE from "three";

export type HitscanResult = {
  point: THREE.Vector3;
  object: THREE.Object3D;
  distance: number;
};

const _raycaster = new THREE.Raycaster();
_raycaster.far = 3000;

const _spreadDir = new THREE.Vector3();

export function isNonCollidable(obj: THREE.Object3D): boolean {
  return !!(obj.userData["isVFX"] || obj.userData["isProjectile"] || obj.userData["isAircraft"] || obj.userData["ignoreBallistics"]);
}

export function hitscan(
  origin: THREE.Vector3,
  dir: THREE.Vector3,
  scene: THREE.Scene,
  spreadRad = 0,
): HitscanResult | null {
  _spreadDir.copy(dir);
  if (spreadRad > 0) {
    _spreadDir.x += (Math.random() - 0.5) * 2 * spreadRad;
    _spreadDir.y += (Math.random() - 0.5) * 2 * spreadRad;
    _spreadDir.z += (Math.random() - 0.5) * 2 * spreadRad;
    _spreadDir.normalize();
  }

  _raycaster.set(origin, _spreadDir);
  const hits = _raycaster.intersectObjects(scene.children, true);

  for (const hit of hits) {
    if (hit.distance < 0.5) continue;
    if (isNonCollidable(hit.object)) continue;
    return { point: hit.point, object: hit.object, distance: hit.distance };
  }
  return null;
}
